export abstract class PaginationStrategyService {
  abstract makePagination();

  getPaginationProps(params: Record<string, string>): Record<string, string> {
      return {};
  }
}
